<script lang="ts">
  import LoadingCard from "$components/forum/Loading/LoadingCard.svelte";
  import ForumThread from "$components/forum/Thread.svelte";
  import api from "$utils/api";
  import { communitySlug } from "app/stores/community";
  import type { NodeViewProps } from "@tiptap/core";
  import { NodeViewWrapper } from "svelte-tiptap";
  import { onMount } from "svelte";
  import type { ForumThreadPermissions } from "@outverse-video/outverse-api-client-lib";
  import type { Thread } from "models/forums";
  import GutterMenu from "$components/editor/extensions/+shared/GutterMenu.svelte";
  import { slugify } from "app/utils/strings";
  import { threadURL } from "app/utils/urls";

  export let node: NodeViewProps["node"];
  export let deleteNode: NodeViewProps["deleteNode"];
  export let isEditable: boolean;
  $$restProps; // prevent svelte unused props warning

  // attributes defined in the TipTap config in ThreadBlock.ts
  const { threadUuid } = node.attrs;

  let thread: Thread | null;
  let permissions: ForumThreadPermissions | undefined;
  let isLoading = true;
  $$restProps; // consume unused tiptap props

  onMount(() => {
    api
      .communitiesThreadsRetrieve({
        communitySlug: $communitySlug,
        uuid: threadUuid,
      })
      .then((resp) => {
        // incompatibility because API type and model type (due to ReplierSerializer/Author discrepency), need to fix
        // root problem
        // @ts-ignore
        thread = resp.data.forumThread;
        permissions = resp.data.myPermissions;
        isLoading = false;
      });
  });
</script>

<NodeViewWrapper>
  {#if isLoading}
    <div class="w-full md:w-5/6">
      <LoadingCard />
    </div>
  {:else}
    <div class="not-prose group relative">
      {#if isEditable}
        <GutterMenu on:delete-block={deleteNode} />
      {/if}

      {#if thread?.uuid}
        <div class="group relative w-full md:w-5/6">
          <a
            class="ov-focus"
            aria-label={`Thread: ${thread.title}`}
            href={threadURL({
              communitySlug: $communitySlug,
              spaceUuid: thread.forumSpace.uuid,
              spaceSlug: slugify(thread.forumSpace.title),
              threadUuid: thread.uuid,
              threadSlug: slugify(thread.title),
            })}
          >
            <ForumThread
              isQuote
              communitySlug={$communitySlug}
              myPermissions={permissions}
              {thread}
              isThreadUpvotesEnabled={false}
            />
          </a>
        </div>
      {/if}
    </div>
  {/if}
</NodeViewWrapper>
